export default __webpack_public_path__ + "static/media/empty-reservation-en.881b7632.png";